import { LocalFireDepartment } from '@mui/icons-material';
import styled from 'styled-components';
import { Typography } from '@mui/material';
import { CenteredFlex } from './Flex';
import Tooltip from './Tooltip';

const PromotedTagStyle = styled(CenteredFlex)`
    background: #ffc400;
    border-radius: 8px;
    padding: 0.4rem 0.8rem;
    margin-inline-end: 10px;
    font-weight: bold;
    color: ${props => props.theme.palette.secondary.main};
    font-weight: bold;
`;

export type PromotedTagProps = {
    text?: string
    tooltipText?: string
}

const PromotedTag = (props: PromotedTagProps): JSX.Element => <PromotedTagStyle>
    <Tooltip title={props.tooltipText || props.text} placement="top">
        <LocalFireDepartment />
    </Tooltip>
    {props.text && <Typography color="secondary" variant="body2" fontWeight="bold">&nbsp;{props.text}</Typography>}
</PromotedTagStyle>;

export default PromotedTag;
